// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___wOyfE","addText":"AddFilterBox__addText___3mDpS","addFilterContainer":"AddFilterBox__addFilterContainer___3C3Ux","addIcon":"AddFilterBox__addIcon___1khXb"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/matches/components/AddFilterBox.scss
// module id = 1611
// module chunks = 0